import { type TileIndex, type TileNeighbour } from "@/types/tile";
import {
	FrameName,
	tilerepoOnlyOneBuildingPerCastleFrameNames,
} from "../config";
import TileEntity, { type TileEntityWithOnRevealMethod } from "../TileEntity";

type SettlementEmptyFrameNames =
	| FrameName.SETTLEMENT_EMPTY
	| FrameName.SETTLEMENT_EMPTY1
	| FrameName.SETTLEMENT_EMPTY2
	| FrameName.SETTLEMENT_EMPTY3
	| FrameName.SETTLEMENT_EMPTY4
	| FrameName.SETTLEMENT_EMPTY5
	| FrameName.SETTLEMENT_EMPTY6
	| FrameName.SETTLEMENT_EMPTY7
	| FrameName.SETTLEMENT_EMPTY8
	| FrameName.SETTLEMENT_EMPTY9
	| FrameName.SETTLEMENT_EMPTY10
	| FrameName.SETTLEMENT_EMPTY11
	| FrameName.SETTLEMENT_EMPTY12
	| FrameName.SETTLEMENT_EMPTY13
	| FrameName.SETTLEMENT_EMPTY14
	| FrameName.SETTLEMENT_EMPTY15
	| FrameName.SETTLEMENT_EMPTY16
	| FrameName.SETTLEMENT_EMPTY17
	| FrameName.SETTLEMENT_EMPTY18
	| FrameName.SETTLEMENT_EMPTY19;

class SettlementEmptyTerrainTileEntity
	extends TileEntity
	implements TileEntityWithOnRevealMethod
{
	public static readonly frameName: SettlementEmptyFrameNames =
		FrameName.SETTLEMENT_EMPTY;

	public get canUpgradeTo(): Set<FrameName> {
		if (this.cachedCanUpgradeTo) return this.cachedCanUpgradeTo;

		if (
			!this.assignedCastleTileEntity ||
			!this.assignedCastleTileEntity.isActive
		)
			return (this.cachedCanUpgradeTo = new Set<FrameName>());

		const upgrades = new Set<FrameName>([...super.canUpgradeTo]);
		if (!this.upgrades.size) return (this.cachedCanUpgradeTo = upgrades);

		const neighbours = this.tilerepo
			.getNeighbourTileIndexesByTileCoordinates(
				{ x: this.x, y: this.y },
				2,
				true,
			)
			.map((tileIndex: TileIndex): TileNeighbour | null => {
				const [, , tileId] =
					this.tilerepo.getTileIdsByTileIndex(tileIndex);
				if (!tileId) return null;

				const frameName = this.tilerepo.getFrameNameByTileId(tileId);
				if (!frameName) return null;

				return {
					tileIndex,
					tileId,
					frameName,
				};
			})
			.filter(
				(neighbour: TileNeighbour | null): boolean =>
					neighbour !== null,
			) as Array<TileNeighbour>;

		// Budovy, ktore mozme mat len po jednej.
		tilerepoOnlyOneBuildingPerCastleFrameNames.forEach(
			(frameName: FrameName): void => {
				if (
					neighbours.some(
						({
							frameName: neighbourFrameName,
						}: TileNeighbour): boolean =>
							frameName === neighbourFrameName,
					)
				) {
					upgrades.delete(frameName);
				}
			},
		);

		return (this.cachedCanUpgradeTo = upgrades);
	}

	public onReveal(): void {
		if (!this.assignedCastleTileEntity) return;
		if ("onReveal" in this.assignedCastleTileEntity)
			this.assignedCastleTileEntity.onReveal();
	}

	public onActivate(): void {
		if (!this.assignedCastleTileEntity) return;
		if ("onActivate" in this.assignedCastleTileEntity)
			this.assignedCastleTileEntity.onActivate();
	}
}

export default SettlementEmptyTerrainTileEntity;
